import React from 'react';
import { Card, Row, Timeline, Col } from 'antd';
import { PrimaryTableRowText } from '../../../../shared/globalStyling/styledText';
import moment from 'moment';
import { ArrowDownOutlined } from '@ant-design/icons';
const { Item } = Timeline;

const SessionExpand = ({ impressions, journey }) => {
  return (
    <Card bodyStyle={{ overflowY: 'auto', height: '500px' }}>
      <Timeline>
        <Item>Impression Journey</Item>
        {impressions && impressions.map(impression => {
          return (
            <Item dot={<ArrowDownOutlined />}>
              <Row>
                <Col span={4}>
                  <PrimaryTableRowText
                    text={`${moment(impression.IMPRESSION_TIME).format('YYYY-MM-DD HH:mm:ss')}`}
                  />
                </Col>
                <Col span={4}>
                  <PrimaryTableRowText text={'Impressions'} />
                </Col>
              </Row>
            </Item>
          );
        })}
        <Item color="green">Session Journey</Item>
        {journey && journey
          .filter(event => event.EVENT !== "record")
          .map(event => {
            return (
              <Item color="green" dot={<ArrowDownOutlined />}>
                <Row>
                  <Col span={4}>
                    <PrimaryTableRowText
                      text={`${moment(event.DATE).format('YYYY-MM-DD HH:mm:ss')}`}
                    />
                  </Col>
                  <Col span={4}>
                    <PrimaryTableRowText text={event.EVENT} />
                  </Col>
                  <Col span={4}>
                    <PrimaryTableRowText text={event.PAGE_URL} />
                  </Col>
                </Row>
              </Item>
            );
          })}
      </Timeline>
    </Card>
  );
};

export default SessionExpand;
